export default __webpack_public_path__ + "static/media/errorimg.68e202a5.png";